import { Button as MButton, type ButtonProps } from "@mantine/core";

export const Button = (
  // eslint-disable-next-line @typescript-eslint/consistent-type-imports
  props: import("@mantine/utils").PolymorphicComponentProps<
    "button",
    ButtonProps
  >,
) => <MButton size="sm" variant="outline" {...props} />;
